// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","expertiseList":"_1laVPD-kcx5ksK1QKZiaQw"};